module.exports = __webpack_public_path__ + "img/tu05a.2e65900a.png";